import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { CreateBatchBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const createBatch = createApiThunk<void, CreateBatchBody>(
  "batches/createBatch",
  async (batch, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.createBatch(batch);
  },
);

export const resetCreateBatch = createAction("batches/resetCreateBatch");
